import { callApi, HTTPMethods } from '@/utils/api';
import KeycloakService from './keycloakService';
import { getApiUrl } from '@/utils/url';
import type { VideoResponse } from '@/types/api';

export default {
  /** GET /video → VideoResponse | null. Pass language for localized resource (fr fallback if missing). */
  async getVideo(language?: string): Promise<VideoResponse | null> {
    await KeycloakService.CallUpdate();
    const config = {
      'Content-Type': 'application/json',
    };
    const qs = language ? `?language=${encodeURIComponent(language.slice(0, 2))}` : '';
    return new Promise((resolve, reject) => {
      callApi({
        path: `${getApiUrl()}/video${qs}`,
        method: HTTPMethods.GET,
        options: config,
        successCallback: (result: VideoResponse | null) =>
          resolve(result ?? null),
        errorCallback: reject,
      }).catch(reject);
    });
  },
};
